import { Flex, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { Typography } from "@kelp-dao/kernel-design-system";
import BaseImage from "@components/BaseImage";
import React from "react";

type VaultPointProps = {
  data: {
    walletConnect: string;
    supported: {
      logo: string;
      title: string;
      tag?: string | string[];
      key: string;
      value?: string;
      isComingSoon?: boolean;
      comingSoonCTA?: string;
    }[];
  };
};

const PointsV2 = ({ data }: VaultPointProps) => {
  const renderTags = (tag?: string | string[]) => {
    if (!tag) return null;
    const parts = Array.isArray(tag)
      ? tag
      : tag
          .split("|")
          .map((p) => p.trim())
          .filter(Boolean);
    return (
      <Flex gap="6px" wrap="wrap">
        {parts.map((t, idx) => (
          <div
            key={`${t}-${idx}`}
            className="rounded-lg px-2 py-0.5 bg-bg-secondary text-text-primary text-xs font-medium"
          >
            {t}
          </div>
        ))}
      </Flex>
    );
  };

  return (
    <Flex p="0" px={{ base: 0, lg: 4 }} direction={"column"} w="100%">
      <Table variant="unstyled" p="0">
        <Thead borderBottom="1px solid #cce5e5">
          <Tr>
            <Th
              fontSize="14px"
              lineHeight="16px"
              fontWeight="400"
              p={2}
              px={0}
              textTransform="none"
              width="40%"
              color="text.secondary"
            >
              Protocol
            </Th>
            <Th
              fontSize="14px"
              lineHeight="16px"
              fontWeight="400"
              p={2}
              px={0}
              textTransform="none"
              width="30%"
              color="text.secondary"
            >
              Benefit
            </Th>
            <Th
              fontSize="14px"
              lineHeight="16px"
              fontWeight="400"
              p={2}
              px={0}
              textTransform="none"
              width="30%"
              color="text.secondary"
              isNumeric
            >
              Points
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.supported.map((row) => (
            <Tr key={row.key}>
              <Td p={2} px={0}>
                <Flex align="center" gap={2}>
                  <BaseImage src={row.logo} width={18} height={18} alt="" />
                  <Typography
                    type="body"
                    variant="small"
                    className="text-sm font-normal text-text-primary"
                  >
                    {row.title}
                  </Typography>
                </Flex>
              </Td>
              <Td p={1} px={0}>
                {renderTags(row.tag)}
              </Td>
              <Td p={1} px={0} isNumeric>
                <Typography
                  type="body"
                  variant="small"
                  className="text-sm font-normal text-text-secondary"
                >
                  {row.value
                    ? row.value
                    : row.isComingSoon
                    ? "Coming soon"
                    : "-"}
                </Typography>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Flex>
  );
};

export default PointsV2;
